
import { Component, Vue, Prop } from 'vue-property-decorator';
import PageBase from "../PageBase.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";
import { stepInfoType, stepResultInfoType } from "@/types/Application";

import {resetProgressOfAllPages} from '@/components/utils/StepsAndPages/StepAndPageFunctions'
import { togglePages, toggleStep, toggleSteps} from '@/components/utils/TogglePages';
import {resetAllPathwaysCompeleted} from '@/components/utils/Pathways/PathwayFunctions'

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import Tooltip from "@/components/survey/Tooltip.vue";

@Component({
    components:{
        PageBase,
        Tooltip,
        LegalAssistanceFaq
    }
})
export default class ReplyToApplication extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[];

    @applicationState.State
    public types!: string[]

    @applicationState.State
    public rejectedPathway!: boolean;

    @applicationState.Action
    public UpdateApplicationType!: (newApplicationType: string[]) => void

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void

    @applicationState.Action
    public UpdateCommonStepResults!: (newCommonStepResults) => void
  
    selected = []; 
    selectedReplyForms = [];  
    showLegalAssistance = false;   
    preparationInfo = false; 
  
    currentStep =0;
    currentPage =0;
    dataReady = false;

    mounted(){ 
        this.dataReady = false;   
        this.preparationInfo = false;     
        this.reloadPageInformation();
    }

    public reloadPageInformation(){               
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.steps[0].result?.selectedReplyApplications) {
            this.selected = this.steps[0].result.selectedReplyApplications;
        }
        
        const progress = this.selected.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);

        this.onChange(this.selected)

        this.dataReady = true;
    }
  
    public onChange(selectedReplyApplications) {
        
        const applicationTypes = []; 

        if (this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedActivity?.includes('applyForOrder') && this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms) {
            for (const form of this.steps[this.stPgNo.GETSTART._StepNo].result?.selectedForms){                    
                applicationTypes.push(this.getApplicationType(form));
            }
        }

        for (const replyForm of selectedReplyApplications){                    
            applicationTypes.push(Vue.filter('getFullOrderName')(replyForm, ''));
        }
      
        this.UpdateApplicationType(Array.from(new Set(applicationTypes)));        
        this.setSteps(selectedReplyApplications);        

        resetAllPathwaysCompeleted();
        resetProgressOfAllPages([], [this.stPgNo.GETSTART._StepNo]);

    }

    public getApplicationType(selectedOrder){
        const step = this.steps[this.stPgNo.PO._StepNo]
        let orgFPOType = ''
        if (selectedOrder == 'protectionOrder' && step.result?.poQuestionnaireSurvey?.data?.orderType){
            orgFPOType = step.result.poQuestionnaireSurvey.data.orderType;
        } 

        return Vue.filter('getFullOrderName')(selectedOrder, orgFPOType);
    }

    public setSteps(selectedReplyApplications) {

        if (selectedReplyApplications !== undefined) {       
        
            const replyFlm = selectedReplyApplications.includes("replyFlm");
            const replyFamilyLawManual = selectedReplyApplications.includes("replyFamilyLawManual");
            const writtenResponse = selectedReplyApplications.includes("replyCaseMgmt") || 
                                    selectedReplyApplications.includes("replyProtectionOrder") || 
                                    selectedReplyApplications.includes("replyPriorityParenting") ||
                                    selectedReplyApplications.includes("replyChildReloc") || 
                                    selectedReplyApplications.includes("replyAgreementEnfrc") || 
                                    selectedReplyApplications.includes("replyFamilyMaintenanceEnfrc");
            const replyCounterApplication = selectedReplyApplications.includes("replyCounterApplication");            

            toggleStep(this.stPgNo.RFLM._StepNo, replyFlm);
            toggleStep(this.stPgNo.WR._StepNo, writtenResponse);
            toggleSteps([this.stPgNo.COMMON._StepNo, this.stPgNo.SUBMIT._StepNo], writtenResponse || replyFlm);
            toggleStep(this.stPgNo.CA._StepNo, replyCounterApplication);
            toggleStep(this.stPgNo.RTFLM._StepNo, replyFamilyLawManual);

            togglePages([this.stPgNo.COMMON.SafetyCheck, this.stPgNo.COMMON.YourInformation, this.stPgNo.COMMON.OtherPartyCommon, this.stPgNo.COMMON.FilingLocation], writtenResponse || replyFlm, this.stPgNo.COMMON._StepNo)

            this.selectedReplyForms =[];
            if(replyFlm) this.selectedReplyForms.push("replyFlm")
            if(replyFamilyLawManual) this.selectedReplyForms.push("replyFamilyLawManual")
            if(writtenResponse) this.selectedReplyForms.push("writtenResponse")
            if(replyCounterApplication) this.selectedReplyForms.push("replyCounterApplication")
            this.UpdateCommonStepResults({data:{'selectedReplyForms':this.selectedReplyForms}})
        }
    }

    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }

    public onNext() {
        if (this.selected.includes("replyFlm")){
            this.preparationInfo = true;
        } else {
            Vue.prototype.$UpdateGotoNextStepPage();
        }                     
    }

    public closePreparationInfo(){
        this.preparationInfo = false;
        Vue.prototype.$UpdateGotoNextStepPage();
    }
  
    beforeDestroy() {
        const progress = this.selected.length==0? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);
        this.UpdateStepResultData({step:this.step, data: {selectedReplyApplications: this.selected}})
    }
}
